import { anyPermission, PermissionId } from "../../app/permissions";
import { getNumber } from "../../app/utils";
import { UserInfo } from "../user/userSlice";
import { HomeworkInfo, HomeworkType } from "./homeworkSlice";

export function hasPermissionToEditHomework(
    user: UserInfo | undefined, 
    classroomId: string | undefined, 
    schoolId: string | undefined
): boolean {
    return (
        ( 
            anyPermission(user, classroomId, [PermissionId.CLASSROOM_ADMIN, PermissionId.CLASSROOM_TEACHER])
        )
        || anyPermission(user, schoolId, [PermissionId.SCHOOL_ADMIN])
    );
}

export function getHomeworkTypeName(type: HomeworkType): string {
    switch(type) {
        case HomeworkType.StudentCheck:
            return "Sem Revisão";
        case HomeworkType.TeacherReviewed:
            return "Revisado pelo Professor";
        default:
            return "Desconhecido";
    }
}

export function emptyHomework(schoolId: number | string, classroomId: number | string): HomeworkInfo {
    return {
        id: 0,
        name: "",
        description: "",
        schoolId: getNumber(schoolId),
        classroomId: getNumber(classroomId),
        startDate: "",
        dueDate: "",
        homeworkType: HomeworkType.StudentCheck,
        createdBy: 0,
        updatedBy: 0,
    } as HomeworkInfo;
}
